import React from 'react';
import propTypes from 'prop-types';
import CarrierLucideIcon from 'components/CarrierLucideIcon/CarrierLucideIcon';
import Button from 'tailwind-components/Button/Button';
import { cn } from 'lib/utils';

const CARRIER_ICON_SIZE = 18;

export default function UntappedRecommendationCarrierCard({
  name,
  carrierIcon,
  carrierIconColor,
  considersStates = false,
  states = [],
  onSeeStates
}) {
  const showSeeStates = considersStates && states.length > 0;

  const handleSeeStates = e => {
    e.stopPropagation();
    onSeeStates?.(name, states);
  };

  return (
    <div
      className={cn(
        'flex min-h-[90px] h-full w-full flex-col items-center justify-center gap-2',
        'rounded-lg border border-grey-lighter bg-white px-3 py-2'
      )}
    >
      <div className='flex w-full flex-col items-center justify-center gap-1'>
        <CarrierLucideIcon
          name={carrierIcon}
          color={carrierIconColor}
          size={CARRIER_ICON_SIZE}
        />
        <span className='text-md w-full text-center font-medium wrap-break-word text-gray-900'>
          {name}
        </span>
      </div>
      {showSeeStates && (
        <Button
          variant='secondary'
          outlined
          size='xsmall'
          text='See states'
          onClick={handleSeeStates}
        />
      )}
    </div>
  );
}

UntappedRecommendationCarrierCard.propTypes = {
  name: propTypes.string.isRequired,
  carrierIcon: propTypes.string,
  carrierIconColor: propTypes.string,
  considersStates: propTypes.bool,
  states: propTypes.arrayOf(propTypes.string),
  onSeeStates: propTypes.func
};
